export default list => list.map((s) => {
  const res = s;
  if (res.hasErrors) delete res.hasErrors;
  return res;
});
